
import store from "../../../../../store";
import { Component, Mixins } from "vue-property-decorator";
import { DomainRegistry } from "../../../../../domain";
import { NewObjectKeys } from "../../../../../domain/configuration";
import { Point } from "../../../../../domain/drawing";
import { IDrawableItem, AbstractVectorItem, AbstractPointsItem, TypeKeys } from "../../../../../domain/document/items";

@Component
export default class ObjectClipboardMixin extends Mixins() {
  get isObjectPastable(): boolean {
    return !!this.objectClipboard;
  }

  private get objectClipboard(): IDrawableItem {
    return store.state.objectClipboard;
  }

  private set objectClipboard(payload: IDrawableItem) {
    store.commit("setObjectClipboard", payload);
  }

  private get newObjectKeyFromObjectClipboard(): NewObjectKeys {
    switch (this.objectClipboard.typeKey) {
      case TypeKeys.BoxLineItem:
        return "NewBoxLine";
      case TypeKeys.CircleItem:
        return "NewCircle";
      case TypeKeys.CrossItem:
        return "NewCross";
      case TypeKeys.LineItem:
        return "NewLine";
      case TypeKeys.PolylineItem:
        return "NewPolyline";
      case TypeKeys.TriangleItem:
        return "NewTriangle";
      case TypeKeys.MovableTextBoxItem:
        return "NewText";
      default:
        return null;
    }
  }

  private get gridPoint(): Point {
    const configuration = store.state.configuration.behavior.document.editor.grid;
    return new Point(configuration.width, configuration.height);
  }

  getObjectCopyable(item: IDrawableItem, containsMovableText: boolean = false): boolean {
    switch (item.typeKey) {
      case TypeKeys.BoxLineItem:
      case TypeKeys.CircleItem:
      case TypeKeys.CrossItem:
      case TypeKeys.LineItem:
      case TypeKeys.PolylineItem:
      case TypeKeys.TriangleItem:
        return item.isAdditional;
      case TypeKeys.MovableTextBoxItem:
        return item.isAdditional && containsMovableText;
      // case TypeKeys.MovableImageItem: // 対象にする場合、GUIDの再発行(アップロード or バックエンドでコピー)処理が必要
      default:
        return false;
    }
  }

  copyToObjectClipboard(item: IDrawableItem): void {
    this.objectClipboard = item;
  }

  async getNewObjectFromObjectClipboard(point?: Point): Promise<IDrawableItem> {
    const repository = DomainRegistry.document.getDocumentRepository();
    const item = await repository.createNewObjects(this.newObjectKeyFromObjectClipboard); // privateId採番のため
    const clone = this.objectClipboard.clone() as IDrawableItem;
    const _point = !!point
      ? point
      : clone.geometry.rectangle.topLeft.add(this.gridPoint);
    clone.privateId = item.privateId;
    if (clone instanceof AbstractVectorItem) {
      const topLeftPoint = new Point(Math.min(clone.vector.from.x, clone.vector.to.x), Math.min(clone.vector.from.y, clone.vector.to.y));
      clone.vector = clone.vector.move(_point.subtract(topLeftPoint));
    } else if (clone instanceof AbstractPointsItem) {
      const basePoint = _point.subtract(clone.geometry.rectangle.topLeft);
      clone.points = clone.points.map(p => basePoint.add(p));
    } else {
      clone.geometry = clone.geometry.moveTo(_point);
    }
    return clone;
  }
}
